goog.provide("shadow.js.shim.module$src$svg$type$file_type$excel_csv_svg");
goog.provide("module$shadow_js_shim_module$src$svg$type$file_type$excel_csv_svg");
shadow.js.shim.module$src$svg$type$file_type$excel_csv_svg = shadow.js.nativeProvides["src/svg/type/file_type/excel-csv.svg"] = shadow$bridge("src/svg/type/file_type/excel-csv.svg");
module$shadow_js_shim_module$src$svg$type$file_type$excel_csv_svg.default = shadow.js.shim.module$src$svg$type$file_type$excel_csv_svg;
